
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/historia-opadow-sniegu",
      function () {
        return require("private-next-pages/[region]/[resort]/historia-opadow-sniegu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/historia-opadow-sniegu"])
      });
    }
  